import Navbar from "../../components/Navbar";
import ServiceHero from "../../components/ServiceHero";
import ServiceProjectCard from "../../components/ServiceProjectCard";
import CTA from "../../components/CTA";
import Footer from "../../components/Footer";
import WhatsAppButton from "../../components/WhatsAppButton";

import placeholderImage from "../../assets/hero-bg.jpg";

const EndToEndGameDevelopment = () => {
  return (
    <>
      <Navbar />

      <ServiceHero
        title="End-to-End Game Development"
        subtitle="From concept to launch, we build complete Unity games with engaging gameplay, polished visuals, and optimized performance."
      />

      <section
        style={{
          background: "#07111e",
          padding: "80px 0 120px"
        }}
      >
        <div
          style={{
            width: "90%",
            maxWidth: "1600px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "60px"
          }}
        >
          <h4
            style={{
              color: "#19d4ff",
              letterSpacing: "2px",
              fontWeight: "700",
              textTransform: "uppercase"
            }}
          >
            OUR WORK
          </h4>

          <ServiceProjectCard
            category="ACTION GAME"
            title="Neon Runner"
            description="A fast-paced action runner built from the ground up, featuring polished gameplay, responsive controls, optimized performance, and immersive visual effects."
            image={placeholderImage}
            onViewDetails={() => {}}
          />

          <ServiceProjectCard
            category="CASUAL GAME"
            title="Sky Puzzle"
            description="Designed and developed a complete casual puzzle experience with intuitive UI, rewarding progression, and cross-platform support."
            image={placeholderImage}
            onViewDetails={() => {}}
          />

          <ServiceProjectCard
            category="MULTIPLAYER"
            title="Battle Arena"
            description="Built an online multiplayer game featuring matchmaking, synchronized gameplay, lobby management, and scalable networking."
            image={placeholderImage}
            onViewDetails={() => {}}
          />
        </div>
      </section>

      <CTA />

      <Footer />

      <WhatsAppButton />
    </>
  );
};

export default EndToEndGameDevelopment;